import Vue from 'vue';
import blocks from '@wordpress/blocks';

interface Ajax {
  url: string;
}
declare module 'vue/types/vue' {
  interface Vue {
    $ajax: Ajax;
  }
}
export default function install (Vue: Vue.VueConstructor) {
  Vue.prototype.$ajax = {
    get url (){
      if (window.location.hostname === 'localhost'){
        return 'https://stage.sprettaktivitetspark.no/wp-admin/admin-ajax.php'
      } else {
        return '/wp-admin/admin-ajax.php';
      }
    },
  }
}